import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

import { LoginResponse } from '../../types'

interface Params {
    token: string
}

const loginSSOUser = async ({ token }: Params) => {
    let url
    if (location.hostname.startsWith('dieteren-training')) {
        url = API_ENDPOINTS.LOGIN_SSO + '?tenant_name=dieteren-training'
    } else {
        url = API_ENDPOINTS.LOGIN_SSO
    }

    return await fetchRequest<LoginResponse>(url, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
    })
}

export default loginSSOUser
